const httpMethods = {
  GET: 'get',
  POST: 'post',
  PUT: 'put',
  PATCH: 'patch',
  DELETE: 'delete',
};

const roleName = {
  SITE_ADMIN: 'Site Admin',
  ORGANIZATION_ADMIN: 'Organization Admin',
  STANDARD_USER: 'Standard User',
  INTEGRATOR: 'Integrator',
};

const roleOptions = [
  { label: 'Site Admin', value: roleName.SITE_ADMIN },
  { label: 'Organization Admin', value: roleName.ORGANIZATION_ADMIN },
  { label: 'Standard User', value: roleName.STANDARD_USER },
];

const poStatusExportOptions = [
  {label: 'Draft', value: 'Draft'},
  {label: 'Requested', value: 'Requested'},
  {label: 'Ordered', value: 'Ordered'},
  {label: 'Rejected', value: 'Rejected'},
  {label: 'Received', value: 'Received'},
  {label: 'Partially Received', value: 'Partially Received'}
];

const poStatusOptions = [
  {name: 'Draft', code: 'Draft'},
  {name: 'Requested', code: 'Requested'},
  {name: 'Ordered', code: 'Ordered'},
  {name: 'Rejected', code: 'Rejected'},
  {name: 'Received', code: 'Received'},
  {name: 'Partially Received', code: 'Partially Received'}
];

const routePaths = {
  FILE_REVIEW_PAGE: '/review/:id',
  LOGIN_PAGE: '/login',
  VERSION_PAGE: '/version',
  LOGOUT_PAGE: '/logout',
  NOT_FOUND_PAGE: '/not-found',
  CONTACT_SUPPORT: '/contact-support',
  PROFILE_PAGE: '/profile',
  UPDATE_PROFILE: '/update-profile',
  ORGANIZATION_PAGE: '/admin/organizations',
  ADMIN_POS_INTEGRATION_PAGE: '/admin/pos-integrations',
  ADMIN_VENDOR_PAGE: '/admin/vendors',
  ADMIN_VENDOR_ASSIGN_PAGE: '/admin/vendors/assign',
  ROLES_PAGE: '/admin/roles',
  ADMIN_USERS_PAGE: '/admin/users',
  ORG_USERS_PAGE: '/organization/users',
  ORG_LOCATION_PAGE: '/organization/location',
  STOCK_PAGE: '/stock',
  PURCHASE_ORDER_PAGE: '/order',
  PURCHASE_ORDER_CREATE_PAGE: '/order/create',
  PURCHASE_ORDER_REQUESTED_PAGE: '/requestedPos',
  PURCHASE_ORDER_DETAIL_PAGE: '/order/item/:id',
  PURCHASE_ORDER_DETAIL: '/order/item',
  PURCHASE_ORDER_REVIEW: '/order/review',
  PURCHASE_ORDER_REVIEW_PAGE: '/order/review/:id',
  STOCK_DETAIL_PAGE: '/stock/:id',
  ORG_REGION_PAGE: '/organization/region',
  ORG_CATEGORY_PAGE: '/organization/category',
  ORG_VENDOR_PAGE: '/organization/vendors',
  ORG_POS_INTEGRATION_PAGE: '/organization/pos-integration',
  ORG_ITEM_PAGE: '/organization/item',
  ORG_OVERVIEW_PAGE: '/organization',
  DASHBOARD_PAGE: '/',
  EMAIL_VERIFICATION: '/email-verification',
  SUBSCRIPTION: '/subscription',
  MY_TOKENS: '/my-tokens',
  MY_SUBSCRIPTIONS: '/my-subscription',
  STRIPE_PAYMENT: '/stripe-payment',
  ADMIN_USER_DETAIL: '/admin/users/:id',
  ORG_USER_DETAIL: '/organization/users/:id',
  SIGNUP: '/signup',
  ORG_NOTIFICATION: '/organization/notifications',
  ORG_REASON_PAGE: '/organization/reason-for-discrepancy',
  NOTICE_BANNER_PAGE: '/notice-banner',
  ORG_NOTICE_BANNER_PAGE: '/organization/notice-banner'
};

const status = {
  ACTIVE: 'Active',
  INACTIVE: 'Inactive',
};

const apiStatus = {
  SUCCESS: 200,
  NO_CONTENT: 204,
  UNAUTHORIZED: 401
};

const defaultpageCount = 10;

const exportFileName = {
  ORGANIZATION: 'ListOrganization.csv',
  USER: ' ListUser.csv',
  USER_ORGANIZATION: 'UserOrganization.csv',
  TOKENS: 'Tokens.csv',
  ROLE: 'Role.csv',
  MY_SUPSCRIPTIONS: 'MySupscriptions.csv',
};

const roles = ['admin', 'user', 'super-admin'];

const tokenKey = 'token';

const searchMaxLength = 500;

const delayShowToast = 2000;

const pageCount = 10;

const acceptImageTypeFile = '.png, .jpeg, .jpg, .gif';

const BUTTON_COLOR = {
  BLUE: 'bg-blue-600 hover:bg-blue-700',
  RED: 'bg-red-500 hover:bg-red-800',
  GRAY: 'bg-gray-300 hover:bg-gray-500',
  OUTLINE: 'bg-white border border-gray-200 hover:bg-blue-100 hover:border-blue-600',
};

const page_default = 0;
const limit_default = 1000;

const INTERVAL = {
  MONTH: 'month',
  YEAR: 'year',
};

const SUBSCRIPTION_TYPE = {
  BASIC: 'Basic',
  STANDARD: 'Standard',
  ENTERPRISE: 'Enterprise',
};

const stripeSucceeded = 'succeeded';
const roleTypeOptions = [
  { label: 'Site', value: 'Site' },
  { label: 'Organization', value: 'Organization' },
];

const ORG_COOKIE_KEY = 'organization_id';
const LOCATION_COOKIE_KEY = 'location_id';
const IMAGE_TYPE_REGEX = /\.(jpg|jpeg|png|gif)$/i;

const permissionKeys = {
  PLATFORM_ADMIN: 'PLATFORM_ADMIN',
  READ_AUTHEN: 'READ_AUTHEN',
  READ_ORG: 'READ_ORG',
  READ_USER: 'READ_USER',
  READ_ROLE: 'READ_ROLE',
  READ_PLAN: 'READ_PLAN',
  READ_SUBSCRIPTION: 'READ_SUBSCRIPTION',
  WRITE_AUTHEN: 'WRITE_AUTHEN',
  WRITE_ORG: 'WRITE_ORG',
  WRITE_USER: 'WRITE_USER',
  WRITE_ROLE: 'WRITE_ROLE',
  WRITE_PLAN: 'WRITE_PLAN',
  WRITE_SUBSCRIPTION: 'WRITE_SUBSCRIPTION',
  READ_LOCATION: 'READ_LOCATION',
  WRITE_LOCATION: 'WRITE_LOCATION',
  READ_REGION: 'READ_REGION',
  WRITE_REGION: 'WRITE_REGION',
  READ_ITEM: 'READ_ITEM',
  WRITE_ITEM: 'WRITE_ITEM',
  READ_CATEGORY: 'READ_CATEGORY',
  READ_VENDOR: 'READ_VENDOR',
  WRITE_CATEGORY: 'WRITE_CATEGORY',
  WRITE_VENDOR: 'WRITE_VENDOR',
  READ_STOCK: 'READ_STOCK',
  WRITE_STOCK: 'WRITE_STOCK',
  READ_REASON: 'READ_REASON',
  WRITE_REASON: 'WRITE_REASON',
  READ_PURCHASE_ORDER: 'READ_PURCHASE_ORDER',
  WRITE_PURCHASE_ORDER: 'WRITE_PURCHASE_ORDER',
  REVIEW_PURCHASE_ORDER: 'REVIEW_PURCHASE_ORDER',
  REASSIGN_PURCHASE_ORDER: 'REASSIGN_PURCHASE_ORDER',
  VIEW_REPORT: 'VIEW_REPORT',
  READ_NOTICE_BANNER: 'READ_NOTICE_BANNER',
  WRITE_NOTICE_BANNER: 'WRITE_NOTICE_BANNER'
};

const integrationVendors = {
  ABC_IGNITE: 'ABC_IGNITE',
  N2G_MLVEDA: 'N2G_MLVEDA',
  DOTFIT: 'DOTFIT',
  MUSCLEFOODS: 'MUSCLEFOODS',
};

const integrationVendorLabels: Record<string, string> = {
  ABC_IGNITE: 'ABC Ignite',
  N2G_MLVEDA: 'N2G / MLVeda',
  DOTFIT: 'DotFit',
  MUSCLEFOODS: 'MuscleFoods',
};

const formatOptions = [
  { label: 'CSV', value: 'CSV' },
  { label: 'API', value: 'API' },
];

const integrationOptions = [
  { label: 'ABC Ignite', value: 'ABC_IGNITE' },
  { label: 'N2G MLVEDA', value: 'N2G_MLVEDA' },
  { label: 'DotFit', value: 'DOTFIT' },
  { label: 'MuscleFoods', value: 'MUSCLEFOODS' },
];

const urlRegex = /^(https?:\/\/)((([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,})|(localhost))(:\d+)?(\/[^\s]*)?$/;

const permissionsSite = [
  permissionKeys.PLATFORM_ADMIN,
  permissionKeys.READ_ORG,
  permissionKeys.READ_USER,
  permissionKeys.READ_ROLE,
  permissionKeys.READ_AUTHEN,
  permissionKeys.READ_VENDOR,
  permissionKeys.WRITE_ORG,
  permissionKeys.WRITE_USER,
  permissionKeys.WRITE_ROLE,
  permissionKeys.WRITE_AUTHEN,
  permissionKeys.WRITE_VENDOR,
];
const permissionsOrg = [permissionKeys.PLATFORM_ADMIN, permissionKeys.READ_ORG, permissionKeys.READ_USER, permissionKeys.WRITE_USER];

const pageType = {
  SITE: 'Site',
  ORGANIZATION: 'Organization',
  LOCATION: 'Location',
};

const sortByTypeType = {
  ASC: 'ASC',
  DESC: 'DESC',
};

const pageSizeOptions = [
  { value: 15, label: 15 },
  { value: 30, label: 30 },
  { value: 45, label: 45 },
  { value: 50, label: 50 },
  { value: 65, label: 65 },
];

export {
  httpMethods,
  roleName,
  roleOptions,
  routePaths,
  status,
  roles,
  defaultpageCount,
  apiStatus,
  exportFileName,
  tokenKey,
  searchMaxLength,
  pageCount,
  delayShowToast,
  acceptImageTypeFile,
  BUTTON_COLOR,
  page_default,
  limit_default,
  INTERVAL,
  SUBSCRIPTION_TYPE,
  roleTypeOptions,
  ORG_COOKIE_KEY,
  LOCATION_COOKIE_KEY,
  stripeSucceeded,
  IMAGE_TYPE_REGEX,
  permissionKeys,
  integrationVendors,
  integrationVendorLabels,
  formatOptions,
  integrationOptions,
  urlRegex,
  pageType,
  permissionsSite,
  permissionsOrg,
  sortByTypeType,
  pageSizeOptions,
  poStatusExportOptions,
  poStatusOptions
};
